const normalizeBase = (baseUrl) => String(baseUrl || '').replace(/\/+$/, '');

export const isPlayerActive = (value) => {
  if (value === true || value === 1) return true;
  if (value === false || value === 0 || value === null || value === undefined) return false;
  const normalized = String(value).trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes';
};

export const fetchAllFootballers = async ({
  baseUrl,
  token,
  fetchImpl = fetch,
  pageSize = 100,
}) => {
  const result = [];
  let start = 0;

  while (true) {
    const params = new URLSearchParams({
      _start: String(start),
      _limit: String(pageSize),
      _sort: 'lastname:ASC',
    });
    const response = await fetchImpl(`${normalizeBase(baseUrl)}/footballers?${params.toString()}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const page = await response.json();
    if (!Array.isArray(page)) throw new Error('Strapi вернул футболистов в неожиданном формате');

    result.push(...page);
    if (page.length < pageSize) break;
    start += page.length;
  }

  return result;
};
